import React, { Component } from "react";
import Modal from "../CustomModal/Modal";
import "./VideoModal.scss";

class VideoModal extends Component {
    constructor(props) {
        super(props);
        this.state = { disable: true };
    }

    componentDidUpdate(prevProps) {
        if (this.props.open && this.props.open !== prevProps.open) {
            this.setState({ disable: true });
        }
    }

    render() {
        let platform = "PLAYER";
        if (this.props.videoData && this.props.videoData.platformName) {
            if (this.props.videoData.platformName.toLowerCase() === "youtube") platform = "YouTube Player";
            else if (this.props.videoData.platformName === "Instagram") platform = "Instagram Player";
            else if (this.props.videoData.platformName === "Twitter") platform = "Twitter Player";
            else if (this.props.videoData.platformName === "X") platform = "X Player";
            else if (this.props.videoData.platformName.toLowerCase() === "facebook") platform = "Facebook Player";
            else platform = this.props.videoData.platformName;
        }

        return (
            <Modal className={this.props.className + " videoPlayer-modal"} show={this.props.open} onClose={() => this.props.hideModal()}>
                <Modal.Header>{platform}</Modal.Header>
                <Modal.Content noSkipGTranslate={true}>
                    {this.props.videoData && (
                        <div className="videoPlayer">
                            <iframe
                                width="100%"
                                height="100%"
                                src={this.props.videoData.url}
                                frameBorder="0"
                                allow="autoplay *; fullscreen *"
                                allowFullScreen
                                onLoad={() => this.setState({ disable: false })}></iframe>
                        </div>
                    )}
                    {this.props.videoData && (
                        <div className="videoTitle">
                            <p>{this.props.videoData.title}</p>
                        </div>
                    )}
                </Modal.Content>
            </Modal>
        );
    }
}

export default VideoModal;
